import { useEffect } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useQuery } from 'react-query'
import posthog from 'posthog-js'
import DotsLoading from 'components/loadings/dotsLoading'
import useGetMoneyPoolManagement from 'pages/fund/fundPage/hooks/useGetMoneyPoolManagement'
import { getFundPoolship } from 'services/fund'
import PayForOther from '.'

/**
 * «پرداخت برای دیگری» opened from a link, not from the members list.
 *
 * The screen reads everything it needs from the navigation state the list's
 * modal builds — which a message button cannot carry. `?poolship=<id>` (the
 * «💳 پرداخت به‌جای …» under a guarantor's حق عضویت follow-up) is turned into
 * that same state here: the member's row and the fund's own details, then
 * one `replace` into the ordinary screen.
 */
export default function PayForOtherEntry() {
    const { state, search, pathname } = useLocation()
    const { moneyPool } = useParams()
    const navigate = useNavigate()
    const poolship = new URLSearchParams(search).get('poolship')
    const fromLink = !state && !!poolship && /^\d+$/.test(poolship)

    const { data: item, isError } = useQuery(
        ['fund-poolship', moneyPool, poolship],
        () => getFundPoolship(moneyPool, poolship as string),
        { enabled: fromLink }
    )
    // the fund's name, the caller's role and its trust state — what the
    // members list's modal hands the screen
    const { moneyPoolManagement } = useGetMoneyPoolManagement(moneyPool)

    useEffect(() => {
        if (!fromLink || !item || !moneyPoolManagement) return
        const role = moneyPoolManagement?.poolship?.role
        posthog.capture('pay_for_other_opened_from_link', {
            fund_id: Number(moneyPool),
        })
        navigate(pathname, {
            replace: true,
            state: {
                item,
                name: moneyPoolManagement.name,
                isManager: role === 'mgr' || role === 'own',
                trustState: moneyPoolManagement.trust_state,
            },
        })
    }, [fromLink, item, moneyPoolManagement, moneyPool, navigate, pathname])

    if (!fromLink) return <PayForOther />
    if (isError)
        return (
            <p className="p-6 text-center text-sm text-text-secondary">
                این عضو پیدا نشد.
            </p>
        )
    return <DotsLoading />
}
